import {
  InclusionCode,
  INTERNATIONAL_AIR_INCLUSION_CODES,
  INTERNATIONAL_AIR_TRANSFER_INCLUSION_CODES
} from "@silversea-ssc/web-inclusions";
import { LinguiT } from "src/utils/localization/lingui-helpers";
import { msg } from "@lingui/core/macro";
import { UnbundlingGroupId } from "@silversea-ssc/ui-components-react";
import {
  CruiseShorexCredit,
  formatShorexCredit
} from "features/shorex/shorex-credit-from-tokens";
import { Currency } from "src/utils/localization/currency";

const internationalAirAndTransferInclusionCodes = [
  ...INTERNATIONAL_AIR_TRANSFER_INCLUSION_CODES,
  ...INTERNATIONAL_AIR_INCLUSION_CODES
];

export const withStandardInclusions = (
  activeInclusions: readonly InclusionCode[]
): InclusionCode[] => {
  return [
    ...new Set([
      ...activeInclusions,
      "Butler",
      "FoodAndBeverage"
    ] as InclusionCode[])
  ];
};

export const activeInclusionsForAirNonAirCountry = (
  activeInclusions: readonly InclusionCode[],
  airCountry: boolean
): readonly InclusionCode[] =>
  airCountry ? activeInclusions : withoutAirInclusions(activeInclusions);

const withoutAirInclusions = (
  inclusions: readonly InclusionCode[]
): readonly InclusionCode[] =>
  inclusions.filter(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (i) => !internationalAirAndTransferInclusionCodes.includes(i as any)
  );

export const infographicGroupLabels = (t: LinguiT) => {
  return {
    cruise: t(msg`all onboard luxury inclusions`),
    "pre-cruise": t(msg`Pre Cruise Air & Transfer`),
    "post-cruise": t(msg`Post Cruise Air & Transfer`),
    shorex: t(msg`Shore Excursions`)
  };
};

export const unbundlingInfographicGroupLabels = (
  t: LinguiT,
  shorexCredit: CruiseShorexCredit | undefined,
  currentCurrency: Currency | undefined
): Record<UnbundlingGroupId, string> => {
  const formattedShorexCredit = formatShorexCredit(
    shorexCredit,
    currentCurrency
  );
  return {
    cruise: t(msg`all onboard luxury inclusions`),
    "pre-cruise": t(msg`Pre Cruise Air & Transfer`),
    "post-cruise": t(msg`Post Cruise Air & Transfer`),
    shorex: t(msg`Shore Excursions`),
    "shorex-credit": formattedShorexCredit
      ? t(msg`${formattedShorexCredit} shore excursions credit`)
      : t(msg`shore excursions credit`),

    "cancellation-policy": t(msg`Cancellation Policy`)
  };
};
